import classNames from "classnames";
import { find, size } from "lodash";
import React, { useEffect, useState } from "react";
import { compose } from "@wordpress/compose";
import { withSelect, withDispatch } from "@wordpress/data";

import { connectSortBy } from "react-instantsearch-dom";

import "./tracks-sort.scss";

const getIndexName = (indexName) => {
  return indexName.replace("HIFI", window.HIFI_APP.HIFI_ALGOLIA_INDEX_NAME);
};

const sortBy = ({
  items,
  refine,
  createURL,
  energyDisplayColumn,
  setEnergyDisplayColumn,
  shapeDisplayColumn,
  setShapeDisplayColumn,
  addAllToSelected,
  removeAllFromSelected,
  tracks,
  selectedTracks,
}) => {
  const title_asc = find(items, { value: getIndexName("HIFI") });
  const title_desc = find(items, { value: getIndexName("HIFI_title_desc") });
  const length_asc = find(items, { value: getIndexName("HIFI_length_asc") });
  const length_desc = find(items, { value: getIndexName("HIFI_length_desc") });
  const [allSelected, setAllSelected] = useState(false);
  const editMode = window.HIFI_APP.HIFI_EDIT_MODE;

  useEffect(() => {
    let allTrackVersions = {};
    tracks.forEach((track) => {
      let versionNumber = 0;
      track.versions &&
        track.versions.forEach((version) => {
          versionNumber++;
          allTrackVersions[`${track.objectID}-${versionNumber}`] = track;
        });
    });

    const allSelectedResult = size(allTrackVersions) === size(selectedTracks);

    setAllSelected(allSelectedResult);
  }, [tracks, selectedTracks]);

  return (
    <div className="tracks-list tracks-header">
      <div className="row">
        {editMode && (
          <div className="col col-checkbox">
            <input
              type="checkbox"
              value="select-all"
              checked={allSelected}
              onClick={() => {
                allSelected ? removeAllFromSelected() : addAllToSelected();
              }}
            />
          </div>
        )}
        <div
          className={classNames({
            col: true,
            "first-col": true,
            "col-title": true,
            sortable: true,
            active: title_asc.isRefined || title_desc.isRefined,
            asc: title_asc.isRefined,
            desc: title_desc.isRefined,
          })}
          onClick={(event) => {
            event.preventDefault();
            title_asc.isRefined
              ? refine(title_desc.value)
              : refine(title_asc.value);
          }}
        >
          <h2>Track Title</h2>
        </div>
        <div className="col col-id">ID</div>
        <div className="col col-artist">Artist</div>
        {editMode && <div className="col col-keyword">Keywords</div>}
        <div
          className={classNames({
            col: true,
            "col-length": true,
            sortable: true,
            active: length_asc.isRefined || length_desc.isRefined,
            asc: length_asc.isRefined,
            desc: length_desc.isRefined,
          })}
          onClick={(event) => {
            event.preventDefault();
            length_asc.isRefined
              ? refine(length_desc.value)
              : refine(length_asc.value);
          }}
        >
          <span>Length</span>
        </div>
        {(editMode || "energy" === energyDisplayColumn) && (
          <div
            className="col col-energy sortable"
            onClick={() => {
              setEnergyDisplayColumn("bpm");
            }}
          >
            Energy
          </div>
        )}
        {(editMode || "bpm" === energyDisplayColumn) && (
          <div
            className="col col-bpm sortable"
            onClick={() => setEnergyDisplayColumn("energy")}
          >
            BPM
          </div>
        )}
        {"icon" === shapeDisplayColumn &&
          "icon" === shapeDisplayColumn &&
          !editMode && (
            <div
              className="col col-shape sortable"
              onClick={() => setShapeDisplayColumn("text")}
            >
              Shape
            </div>
          )}
        {(editMode || "text" === shapeDisplayColumn) && (
          <div
            className="col col-shape sortable"
            onClick={() => setShapeDisplayColumn("icon")}
          >
            Shape
          </div>
        )}
        <div className="col col-customizable">Customizable</div>
        {editMode && <div className="col col-status">Status</div>}
        <div className="col col-versions">Versions</div>
        <div className="col col-waveform">&nbsp;</div>
        <div className="col col-buttons">&nbsp;</div>
      </div>
    </div>
  );
};

const SortBy = compose(
  withSelect((select, ownProps) => {
    const {
      getEnergyDisplayColumn,
      getShapeDisplayColumn,
      getSelectedTracks,
      getTracks,
    } = select("hifi");

    return {
      ...ownProps,
      energyDisplayColumn: getEnergyDisplayColumn(),
      shapeDisplayColumn: getShapeDisplayColumn(),
      selectedTracks: getSelectedTracks(),
      tracks: getTracks(),
    };
  }),
  withDispatch((dispatch) => {
    const {
      setEnergyDisplayColumn,
      setShapeDisplayColumn,
      addAllToSelected,
      removeAllFromSelected,
    } = dispatch("hifi");

    return {
      setEnergyDisplayColumn,
      setShapeDisplayColumn,
      addAllToSelected,
      removeAllFromSelected,
    };
  })
)(sortBy);

const TrackColumnsSort = connectSortBy(SortBy);

export default TrackColumnsSort;
